'use client'

import { useState } from 'react'

import { DesktopCarousel } from '@src/components/ProductConfigurator/modules/ProductGalleryV2/DesktopCarousel'
import { MobileCarousel } from '@src/components/ProductConfigurator/modules/ProductGalleryV2/MobileCarousel'
import { usePDP } from '@src/hooks/usePDP'
import { useLocale } from '@src/i18n/LocaleProvider'
import { useBreakpoints } from '@src/utils/breakpoints.util'
import { getImage } from '@src/utils/product.util'

export default function ProductGalleryV2() {
  const { locale } = useLocale('common')
  const { viewModel } = usePDP()
  const variantAssets = viewModel?.selectedVariant?.assets ?? []
  const productAssets = viewModel?.product?.assets ?? []
  const images = [...variantAssets, ...productAssets].map((asset) => getImage(asset, locale.code))

  const [isModalOpen, setIsModalOpen] = useState(false)

  const { isDesktop } = useBreakpoints()

  return (
    <div className="mb-4 h-full">
      {isDesktop ? (
        <DesktopCarousel
          images={images}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
        />
      ) : (
        <MobileCarousel images={images} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
      )}
    </div>
  )
}
